// extracted by mini-css-extract-plugin
export var content = "subscribe-third-module--content--a3a7c";
export var grid = "subscribe-third-module--grid--c4687";
export var spin = "subscribe-third-module--spin--a5702";
export var video = "subscribe-third-module--video--ef011";